<template>
  <div class="home">
    <Header />
    <Swipe ref="swipe"  />
    <Content @opend="opend" /> 
    <Footter /> 
    <!-- <router-view /> -->
    <!-- <Menu /> -->
    <!-- <img alt="Vue logo" @click="getProvince" src="../assets/logo.png">
    <img alt="Vue logo" @click="getEducation" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App xiaojj" /> -->
    
  </div>
</template>

<script>
// @ is an alias to /src
import Header from './Header.vue';
import Swipe from './swipe.vue';
import Content from './Contentt.vue';
import Footter from './footter.vue';

export default {
  name: 'Home',
  data() {
    return {
      proList: [],
    };
  },
  components: {
    Header,
    Swipe,
    Content,
    Footter
  },
  created() {
    // if (!this.$store.state.token) {
    //   this.$router.push({
    //     path: '/login'
    //   });
    // }
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
  },
  methods: {
    opend(){
      console.log('ok')
      this.$refs['swipe'].openDrawf()
    },
    async getProvince() {
      let result = await this.$api.instance.getProvince();
      console.log(result);
    },
    async getEducation() {
      let result = await this.$api.instance.getEducation();
      console.log(result);
    },
    async getStudentApply() {
      let params = {
        page: 1,
        size: 100,
      };
      let result = await this.$api.instance.getStudentApply(params);
      console.log(result);
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  height: 100vh;
  width: 100%;
  // overflow-x: hidden;
  // background: #acbfa8;
}
</style>
